import { render } from "./GameBattle.vue?vue&type=template&id=1b732b66"
import script from "./GameBattle.vue?vue&type=script&lang=js"
export * from "./GameBattle.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__